// extracted by mini-css-extract-plugin
export var button = "exercise-card-module--button--fhsnf";
export var card = "exercise-card-module--card--aJckd";
export var iconWrapper = "exercise-card-module--icon-wrapper--wNFiG";
export var img = "exercise-card-module--img--8oeFo";
export var imgWrapper = "exercise-card-module--img-wrapper--um-8b";
export var locked = "exercise-card-module--locked--BQo-i";
export var metadata = "exercise-card-module--metadata--4LxVx";
export var ratioClass = "exercise-card-module--ratio-class--74hW9";
export var title = "exercise-card-module--title--gPl5S";